module.exports = __webpack_public_path__ + "media/images/emblems/Oberhasli-coat_of_arms-00d0bef2d18ed69b468b8ed980e2cced.svg";